// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"51f932e3f758f88522d1","9249":"402a3bb32f41b8970aac"}[chunkId] + ".chunk.js";
};